import type { IJourney } from '../../../../models/journey.model';
import { ProductType } from '../../../../models/product-type.enum';
import JourneyTicketSuggestions from '../../../Shared/JourneySearchResults/JourneyTicketSuggestions';
import JourneySummary from '../../../Shared/JourneySearchResults/JourneySummary';
import LowestTicketPrices from '../LowestTicketPrices';
import ExpandableListItem from '../../../Shared/JourneySearchResults/ExpandableListItem';
import { JourneyDetailsApiModel } from '../../../../services/api-planera-resa/models/journey-details/journey-details.api-model';
import type { IJourneyDetails } from '../../../../models/journey-details.model';
import Spinner from '../../../Shared/Spinner';
import GeneralError from '../../../Shared/GeneralError';
import useFetch, { DataSource, Status } from '../../../../hooks/fetch.hook';

function processReceivedData(data: JourneyDetailsApiModel | undefined): IJourneyDetails | undefined {
  return data ? JourneyDetailsApiModel.mapToBusinessModel(data) : undefined;
}

function SingleTicketsResultItem({ journey, index, priceDisclaimerId }: { journey: IJourney; index: number; priceDisclaimerId: string }) {
  // === STATE ===
  const [{ status: getJourneyDetailsStatus, data: getJourneyDetailsData }] = useFetch<JourneyDetailsApiModel>(
    `/journeys/${journey.detailsReference}/details?includes=ticketsuggestions&productTypes=${ProductType.singleTicket}&productTypes=${ProductType.prepaidTicket}`,
    false,
    false,
    {
      dataSource: DataSource.apiPlaneraResa,
      keepLastStateIfPrevented: false,
      delayInMs: 0,
    }
  );

  // === VARIABLES ===
  const receivedTicketSuggestions = processReceivedData(getJourneyDetailsData)?.ticketSuggestions ?? [];

  return (
    <ExpandableListItem
      id={`result-item-${index}`}
      collapsedContent={
        <>
          <JourneySummary journey={journey} />
          <LowestTicketPrices ticketSuggestions={receivedTicketSuggestions} priceDisclaimerId={priceDisclaimerId} />
        </>
      }
      renderExpandedContent={() => (
        <>
          <div id={`result-item-${index}-details`} className="border-top pt-3 fade show active" role="tabpanel">
            {getJourneyDetailsStatus === Status.loading && <Spinner delayInMs={0} />}
            {getJourneyDetailsStatus === Status.success && <JourneyTicketSuggestions journey={journey} ticketSuggestions={receivedTicketSuggestions}></JourneyTicketSuggestions>}
            {getJourneyDetailsStatus === Status.failed && <GeneralError />}
          </div>
        </>
      )}
    ></ExpandableListItem>
  );
}

export default SingleTicketsResultItem;
